<template>
  <div>
    <BaseInputPhone
      v-model="model.phone"
      :name="inputNamePhone"
      optional="optional"
      @submit="onSubmit"
    />
    <BaseInputEmail
      v-model="model.email"
      :name="inputNameEmail"
      optional="optional"
      @submit="onSubmit"
    />
    <ConsentCheck
      id="consent"
      v-model="model.optIns.terms"
      :name="checkboxTerms"
      :required="isConsentTermsRequired"
      @click="clickDLPush('nutzungsbedingungendatenschutz-zustimmen', 'checkboxclick')"
    >
      <ConsentNoticePrivacy />
    </ConsentCheck>
    <ConsentCheck
      id="feedbackOptIn"
      v-model="model.optIns.feedback"
      :name="checkboxFeedback"
      @click="clickDLPush('einwilligung-terminbewertung', 'checkboxclick')"
    >
      <ConsentNoticeFeedback />
    </ConsentCheck>
    <ButtonGroup>
      <BaseButton :disabled="hasErrors" @click="onSubmit">
        {{ buttonLabel }}
      </BaseButton>
    </ButtonGroup>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useForm } from 'vee-validate'
import { isEmpty } from 'lodash-es'
import ConsentNoticePrivacy from '~/base/components/consentNotice/ConsentNoticePrivacy.vue'
import ConsentCheck from '~/base/components/consentCheck/ConsentCheck.vue'
import { useDataLayerMixin } from '~/base/composables/useDataLayer'
import ButtonGroup from '~/base/components/buttonGroup/ButtonGroup.vue'
import ConsentNoticeFeedback from '~/base/components/consentNotice/ConsentNoticeFeedback.vue'
import BaseInputPhone from '~/base/components/input/InputPhone.vue'
import BaseInputEmail from '~/base/components/input/InputEmail.vue'
import type { UpdateContactInfoForm } from '~/terminierungsportal/components/updateContactInfo/updateContactInfoForm'
import {
  checkboxFeedback,
  checkboxTerms,
  inputNameEmail,
  inputNamePhone
} from '~/terminierungsportal/components/updateContactInfo/updateContactInfoForm'

interface UpdateContactInfoProps {
  modelValue: UpdateContactInfoForm
  buttonLabel?: string
}

const props = defineProps<UpdateContactInfoProps>()
const emits = defineEmits(['submit', 'update:modelValue'])
const { handleSubmit, errors, validate } = useForm()
const { clickDLPush } = useDataLayerMixin()
const model = computed<UpdateContactInfoForm>({
  get: () => {
    return props.modelValue
  },
  set: (newValue) => {
    emits('update:modelValue', newValue)
    setTimeout(() => validate({ mode: 'force' }), 10)
  }
})

const hasErrors = computed(() => {
  return !!Object.keys(errors.value).length
})
const isConsentTermsRequired = computed(() => {
  return !isEmpty(props.modelValue.email) || !isEmpty(props.modelValue.phone)
})

const onSubmit = handleSubmit((values: Record<string, unknown>) => {
  if (hasErrors.value) {
    return
  }
  emits('submit', values)
})
</script>
